export const routes = {
    admin: '/admin',
    adminOpenApiRoutes: '/admin/openapi',
    policyEditor: '/policy-editor',
    templateEditor: '/template-editor',
    argumentMetadataView: '/arguments',
    ticket: '/ticket',
    onlineTicket: '/online/ticket',
};
